import { render, staticRenderFns } from "./FoldersRecucler.vue?vue&type=template&id=83f79ee6&"
import script from "./FoldersRecucler.vue?vue&type=script&lang=ts&"
export * from "./FoldersRecucler.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports